import React from "react";
import PropTypes from "prop-types";
import Nav from "reactstrap/lib/Nav";

import HeaderbarRespUtils from "../../lib/headerbarRespUtils";
import { OrionContext } from "../orionContext/orionContext";
import "./headerbarResponsive.scss";

class HeaderbarResponsive extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.headerbarRespUtils = new HeaderbarRespUtils(
      props.onItemClick,
      context
    );
  }

  render() {
    const { left, right } = this.props;
    return (
      <div
        data-testid="orion-headerbar-responsive"
        className="oui-headerbar-resp-container oui-invert-scroll"
      >
        <div className="oui-position-relative">
          <div className="oui-separator-line" />
        </div>
        <Nav vertical>
          {this.headerbarRespUtils.renderComponents(left, "nav-left")}
        </Nav>
        <Nav vertical>
          {this.headerbarRespUtils.renderComponents(right, "nav-right")}
        </Nav>
      </div>
    );
  }
}

HeaderbarResponsive.contextType = OrionContext;

HeaderbarResponsive.propTypes = {
  left: PropTypes.array,
  right: PropTypes.array,
  onItemClick: PropTypes.func
};

HeaderbarResponsive.defaultProps = {
  left: [],
  right: []
};

HeaderbarResponsive.displayName = "OrionHeaderbarResponsive";

export default HeaderbarResponsive;
